import React from 'react'
import { Image } from 'newComponents'

import './styles.scss'

const WebinarSeriesHead = ({ data }) => {
  const {
    primary: { hero_title: heroTitle, hero_subtitle: heroSubtitle, logo }
  } = data

  const title = heroTitle?.text
  const subTitle = heroSubtitle?.text
  const logoUrl = logo?.url

  return (
    <section className="webinar-series-hero">
      <div className="webinar-series-hero-inner container">
        <div className="webinar-series-hero-content-wrapper">
          <div className="webinar-series-hero-logo">
            <Image image={logoUrl} />
          </div>
          <h1>
            <span className="webinar-series-hero-title">{title}</span>
            <span className="webinar-series-hero-sub-title">{subTitle}</span>
          </h1>
        </div>
      </div>
    </section>
  )
}

export default WebinarSeriesHead
